import './_promobar-carousel.scss';
import component from './promobar-carousel';

export default component;
